import type { JSX } from "react";
import { cn } from "@/lib/utils";

interface Props {
  content: React.ReactNode | undefined;
  className?: string;
}

export const FormErrorMessage = (props: Props): JSX.Element => {
  if (props.content == undefined) {
    return <></>;
  }
  return (
    <p
      className={cn(
        "text-[0.9rem] mt-1 font-medium text-destructive",
        props.className,
      )}
    >
      {props.content}
    </p>
  );
};
